import { Grid, Image, Empty } from 'antd-mobile'
import React, { useState } from 'react'
import Icon from '../../icon'

const MvpDetail = ({ mvpInfo, mvpDetail, getMvpDetailInfo, memberList }) => {
    const [expandedId, setExpandedId] = useState(null);

    // 根据memberId获取成员信息
    const getMemberInfo = (memberId) => {
        return memberList.find(item => item.id === memberId) || {};
    };

    const toggleExpand = (id) => {
        if (expandedId === id) {
            setExpandedId(null);
        } else {
            setExpandedId(id);
            getMvpDetailInfo(id);
        }
    }

    // Helper to render voting details (the grids)
    const renderVoteDetails = (member) => {
        if (!mvpDetail || !mvpDetail.length) return <div style={{ padding: 10, textAlign: 'center', color: '#666' }}>暂无投票详情</div>;

        const currentMemberInfo = getMemberInfo(member.id);
        const currentTeam = currentMemberInfo.gameTeam;

        const opponents = [];
        const referees = [];
        const teammates = [];
        const selfVotes = [];
        const observers = [];

        mvpDetail.forEach(user => {
            const voterInfo = getMemberInfo(user.memberId);
            const { gameTeam, gameType, name } = voterInfo;

            const isSelf = member.id === user.memberId;
            const isSameTeam = gameTeam === currentTeam;
            const isDifferentTeam = gameTeam !== currentTeam && (gameTeam === 1 || gameTeam === 2);
            const isReferee = gameType > 0 && gameType < 5;
            const isObserver = gameType > 4 || gameType === null;

            if (isSelf) {
                selfVotes.push(`${name || ''}👍+1.5`);
            } else if (isSameTeam) {
                teammates.push(`${name || ''}👍+2`);
            } else if (isDifferentTeam) {
                opponents.push(`${name || ''}👍+3`);
            } else if (isReferee) {
                referees.push(`${name || ''}👍+3`);
            } else if (isObserver) {
                observers.push(`${name || ''}👍+1`);
            }
        });

        return (
            <div style={{ padding: '12px', background: 'rgba(255,255,255,0.6)', borderTop: '1px solid rgba(0,0,0,0.05)', color: '#86909C' }}>
                <Grid columns={3} gap={4}>
                    <Grid.Item>
                        <div style={{ fontSize: '12px', color: '#86909C', marginBottom: 4 }}>
                            <div>对手 (+3)</div>
                            <div>裁判 (+3)</div>
                        </div>
                        {[...opponents, ...referees].map((t, i) => <div key={`c1-${i}`} style={{ fontSize: '13px', color: '#4E5969', marginBottom: 2 }}>{t}</div>)}
                    </Grid.Item>
                    <Grid.Item>
                        <div style={{ fontSize: '12px', color: '#86909C', marginBottom: 4 }}>
                            <div>队友 (+2)</div>
                            <div style={{ visibility: 'hidden' }}>占位</div>
                        </div>
                        {teammates.map((t, i) => <div key={`c2-${i}`} style={{ fontSize: '13px', color: '#4E5969', marginBottom: 2 }}>{t}</div>)}
                    </Grid.Item>
                    <Grid.Item>
                        <div style={{ fontSize: '12px', color: '#86909C', marginBottom: 4 }}>
                            <div>自投(+1.5)</div>
                            <div>吃瓜 (+1)</div>
                        </div>
                        {[...selfVotes, ...observers].map((t, i) => <div key={`c3-${i}`} style={{ fontSize: '13px', color: '#4E5969', marginBottom: 2 }}>{t}</div>)}
                    </Grid.Item>
                </Grid>
            </div>
        )
    };

    if (mvpInfo && mvpInfo.length > 0) {
        // Sort by score
        const sorted = [...mvpInfo].sort((a, b) => b.mvpCount - a.mvpCount);
        const winner = sorted[0];
        const others = sorted.slice(1);

        return (
            <div>
                {/* MVP 第一名突出展示，统计信息使用高对比度样式避免看不清。 */}
                <div className="mvp-spotlight-card" onClick={() => toggleExpand(winner.id)}>
                    <div className="mvp-winner-row">
                        <div className="mvp-winner-main">
                            <Image
                                src={winner.image + Icon.ImageFooter}
                                width={56} height={56} fit='cover'
                                style={{ borderRadius: '50%', border: '3px solid #f59e0b', boxShadow: '0 4px 20px rgba(22, 93, 255, 0.1), inset 0 0 0 1px rgba(22, 93, 255, 0.05)' }}
                            />
                            <div className="mvp-winner-content">
                                <div className="mvp-winner-title">
                                    <span className="mvp-winner-name">{winner.likeMemberName}</span>
                                    <span className="mvp-badge">MVP</span>
                                </div>
                                <div className="mvp-winner-stats">
                                    <span className="mvp-stat-chip">
                                        <span className="mvp-stat-label">总分</span>
                                        <span className="mvp-stat-value">{winner.mvpCount}</span>
                                    </span>
                                    <span className="mvp-stat-chip">
                                        <span className="mvp-stat-label">总票数</span>
                                        <span className="mvp-stat-value">{winner.voteNum}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="mvp-trophy">🏆</div>
                    </div>
                    {expandedId === winner.id && renderVoteDetails(winner)}
                </div>

                {/* Others List */}
                {others.map((member, idx) => (
                    <div key={member.id} className="mvp-rank-item" style={{ display: 'block' }} onClick={() => toggleExpand(member.id)}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                <div style={{ width: '24px', textAlign: 'center', fontWeight: 'bold', color: '#86909C', marginRight: '10px' }}>
                                    {idx + 2}
                                </div>
                                <Image
                                    src={member.image + Icon.ImageFooter}
                                    width={32} height={32} fit='cover'
                                    style={{ borderRadius: '50%', border: `2px solid #F5F7FA`, backgroundColor: '#F5F7FA' }}
                                />
                                <div style={{ marginLeft: '12px' }}>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#1D2129' }}>{member.likeMemberName}</div>
                                </div>
                            </div>
                            <div style={{ fontSize: '14px', fontWeight: '700', color: '#1D2129' }}>
                                {member.mvpCount}分 <span style={{ fontSize: '11px', fontWeight: 'normal', color: '#86909C', marginLeft: '4px' }}>({member.voteNum}票)</span>
                            </div>
                        </div>
                        {expandedId === member.id && renderVoteDetails(member)}
                    </div>
                ))}
            </div>
        );
    }

    return <Empty description="暂无MVP数据" style={{ marginTop: 50 }} imageStyle={{ width: 100 }} />;
};

export default MvpDetail;
